var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.toChat(_vm.item)}}},[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":require("@/assets/hideBox/jiaoliu.png"),"alt":""}}),_c('span',[_vm._v("交流")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }